import React from "react";
import { Tooltip } from 'antd';
import ColorButton from "../../common/ColorButton";
import TSTable from "../../common/TSTable";
import { LAB_COLOR } from "../../constants/color";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFlask } from "@fortawesome/free-solid-svg-icons";
import LabResultsModal from "../lab-latex/LabResultsModal";
import { URL_LAB } from "../../constants/urls";
import { dateTimeToHumanString } from "../../frameworks/Util";
import { LAB_ORDER_DETAIL_TH, LAB_ORDER_TYPE_TH, LAB_ORDER_DETAIL, POND_STATUS_TH, LAB_TYPE_OPTIONS, TANK_STATUS_TH, LAB_ORDER_TYPE } from "../../constants/string";
import _ from "lodash";

export default function LabTaskList(props) {
  const [ target, setTarget ] = React.useState(null);
  const tableRef = React.useRef(null);

  const refreshData = async() => {
    if(tableRef.current)(
      await tableRef.current.fetchWithoutResetPage()
    )
  }

  const columns = [
    {
      title: 'Action',
      dataIndex: '',
      key: 'action',
      render: (_, original) => {
        return (
          <div 
            style={{textAlign:'center'}}
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            <Tooltip triger='hover' title={"ส่งผลแล็บ"}>
              <ColorButton 
                type='primary'
                override={LAB_COLOR}
                icon={<FontAwesomeIcon icon={faFlask}/>}
                onClick={()=> setTarget(original)} 
              />
            </Tooltip>
          </div>
      )}
    },
    {
      title: 'Order No.',
      dataIndex: 'code',
      key: 'code',
      width : 180,
      searcher : true,
    },
    {
      title: 'วันที่',
      dataIndex: 'created',
      key: 'created',
      render: (value) => dateTimeToHumanString(value),
      width : 180
    },
    {
      title: 'ประเภท',
      dataIndex: 'type',
      key: 'type',
      width : 150,
      searcher: true,
      searcherOptions: LAB_TYPE_OPTIONS,
      render : (value) => _.get(LAB_ORDER_TYPE_TH, value, '-')
    },
    {
      title: 'รายละเอียด',
      dataIndex: 'ref_detail',
      key: 'ref_detail',
      render : (value, original) => 
        Object.entries(value)
          .map(([key, value]) => {
            const isState = key === LAB_ORDER_DETAIL.STATE
            const statusMapper = original.type == LAB_ORDER_TYPE.POND ? POND_STATUS_TH : TANK_STATUS_TH
            return value && LAB_ORDER_DETAIL_TH[key] && (
              <div>
                {_.get(LAB_ORDER_DETAIL_TH, key, '-')} : {isState ? statusMapper[value] : value }
              </div>
            )
          })
    },
  ]

  React.useEffect(() => {
    const interval = setInterval(() => {
      refreshData();
    }, 300000);

    return () => clearInterval(interval);
  }, []);

  return(
    <div>
      <TSTable
        ref={tableRef}
        columns={columns}
        size={'small'}
        url={URL_LAB.LAB_ORDER}
        params={{status : 'progressing', type : props.type ? props.type : '', concentrate : props.concentrate ? true : ''}}
      />

      <LabResultsModal
        open={target ? true : false}
        onClose={() => {
          setTarget(null)
        }}
        target={target}
        onUpdate={() => {
          setTarget(null)
          refreshData();
        }}
      />
    </div>
  )
}